import { render } from "./ViewAllStaff.vue?vue&type=template&id=c2a19834&scoped=true"
import script from "./ViewAllStaff.vue?vue&type=script&lang=js"
export * from "./ViewAllStaff.vue?vue&type=script&lang=js"

import "./ViewAllStaff.vue?vue&type=style&index=0&id=c2a19834&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2a19834"]])

export default __exports__